/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ExceptionReviewRetrieval = {
    uuid: string;
    exception: string;
    review_date?: string;
    /**
     * Reviewer of the exception.
     */
    reviewer: string;
    status?: ExceptionReviewRetrieval.status;
    notes?: string | null;
}

export namespace ExceptionReviewRetrieval {

    export enum status {
        UNKNOWN = 'unknown',
        APPROVED = 'approved',
        DENIED = 'denied',
        TENTATIVE = 'tentative',
    }


}
